export default [
    {
        path: '/admin/academic/accessor-certificate-requests',
        name: 'accessor-certificate-request',
        meta: { requiresAuth: true },
        component: () => import('@/pages/academic/accessor-certificate-request/index.vue')
    },
    {
        path: '/admin/academic/accessor-certificate-requests/accessor-certificate-approve/:candidate_id/:request_skill_id/:request_id',
        name: 'accessor-certificate-approve',
        meta: { requiresAuth: true },
        component: () => import('@/pages/academic/accessor-certificate-request/accessor-certificate-approve.vue')
    },

]
